const combineAttributes = (
    attributes?: {
        name: string;
        value: string;
    }[]
) => ({
    name: attributes?.map(({ name }) => name).join(' / ') ?? '',
    value: attributes?.map(({ value }) => value).join(' / ') ?? '',
});

export default combineAttributes;
